module.exports = "/_next/static/images/74965bf93f52dabee078b8c200b6b350-steps-desktop.jpg.webp";